/**
 * Load More button component
 */

if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.productsContainer = document.querySelector('[data-load-more-grid]');
      this.loadMoreBtn = this.querySelector('[data-load-more-btn]');
      this.count = this.querySelector('[data-count]');
      this.totalItems = parseInt(this.dataset.total);
      this.page = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;

      if (this.productsContainer && this.loadMoreBtn) {
        this.loadMoreBtn.addEventListener('click', this.loadMore.bind(this));
      }
    }

    loadMore() {
      if (this.page >= parseInt(this.dataset.totalPages)) {
        this.loadMoreBtn.classList.add('hidden');
        return;
      }

      this.loadMoreBtn.setAttribute('disabled', 'disabled');
      this.page++;

      const search = new URLSearchParams(window.location.search);
      search.set('page', this.page);
      const url = `${window.location.pathname}?${search}`;

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll('[data-load-more-grid] > *');
          
          this.productsContainer.append(...newProducts);

          if (this.count) {
            const remaining = this.totalItems - this.productsContainer.children.length;
            this.count.innerHTML = Math.min(remaining, parseInt(this.dataset.limit));
          }

          // Hide or enable button
          if (this.page >= parseInt(this.dataset.totalPages)) {
            this.loadMoreBtn.classList.add('hidden');
          } else {
            this.loadMoreBtn.removeAttribute('disabled');
          }

          window.history.pushState({}, '', url);
        });
    }
  }

  customElements.define('load-more', LoadMore);
}